import InterExtraBoldTtf from '../../../assets/fonts/Inter-ExtraBold.woff2';
import InterSemiBoldTtf from '../../../assets/fonts/Inter-SemiBold.woff2';

export default [
  {
    name: 'InterExtraBold',
    path: InterExtraBoldTtf,
  },
  {
    name: 'InterSemiBold',
    path: InterSemiBoldTtf,
  },
]
